import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { fetchAuthMe, loginUser, logoutUser } from "../api/auth"

export const AUTH_USER_KEY = ["auth", "user"]

export const useAuthUser = () =>
  useQuery({
    queryKey: AUTH_USER_KEY,
    queryFn: fetchAuthMe,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  })

export const useLogin = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: loginUser,
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: AUTH_USER_KEY })
    },
  })
}

export const useLogout = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: logoutUser,
    onSuccess: () => {
      queryClient.clear()
    },
    onError: () => {
      toast.error("Failed to log out. Please try again.")
    },
  })
}
